import AbstractEditorController from './abstract-editor-controller';

class DocumentTemplatesDetailsController extends AbstractEditorController {
    constructor($scope, $injector) {
        super($scope, $injector);
        this.workflows = this.injector.get('Workflows');
        this.allowRoute = true;

        this.injector.get('$q').all([
            this._loadAndStoreDeposits(),
            this._loadModel()
        ]).then(() => {
            this.loading = false;
            this._prepareNavServiceStuff();
            this._updateDetailsNav();
        });
    }

    editModel() {
        this.angularState.go('app.documents.templates.edit', {
            id: this.model.id
        });
    }

    trustTemplateHtml(string) {
        return this.injector.get('$sce').trustAsHtml(string);
    }

    _prepareNavServiceStuff() {
        const actions = _(this.workflows.getWorkflows('documents::template-details'))
            .filter(workflow => {
                return this.model.archived ? workflow.level === 'archived-highlight' : workflow.level === 'highlight';
            })
            .map(workflow => {
                if (!workflow.onClick) {
                    workflow.onClick = workflow.action;
                }
                workflow.action = () => {
                    workflow.onClick(this.model, this);
                };
                workflow.order = workflow.order || 30;
                return workflow;
            })
            .sortBy('order', 'asc')
            .value();

        this.navService.overrideMainSideNavActions(actions);
    }
}

/**
 * @ngdoc object
 * @name contacts.documents.templates:DocumentsTemplatesDetailsCtrl
 *
 * @description
 *
 */
angular
    .module('festzelt-os.documents.templates')
    .controller('DocumentsTemplatesDetailsCtrl', DocumentTemplatesDetailsController);



// WEBPACK FOOTER //
// ./src/app/pages/documents/templates/controllers/details-controller.js